import React from "react";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PrivateRoute from "./utils/privateRoute";
import AdminRoute from "./utils/adminRoute";
import UserRoute from "./utils/userRoute";
import useQuery from "./utils/useQuery";
//Components
import Login from "./containers/login";
import SignUp from "./containers/signup";
import ForgetPassword from "./components/forgetPassword";
import ResetPassword from "./components/resetPassword";
import Dashboard from "./containers/dashboard";
import CreateQuery from "./containers/createQuery";
import QueryDetails from "./containers/queryDetails";
import EditQuery from "./containers/editQuery";
import AddUser from "./components/adduser";
import UserList from "./components/userList";
import UserProfile from "./components/userProfile";
import AdminLoginContainer from "./components/adminLoginContainer";
import AdminUserSignup from "./components/AdminUserSignup";
import ForgetUsername from "./components/forgetUsername";
import ConsultantLoginContainer from "./components/consultantLoginContainer";
import ConsultantForgetPassword from "./components/consultantForgetPassword";
//scss
import "./assets/scss/main.scss";
import EndUserList from "./components/enduserList";



const App = () => {
  const { queryData } = useQuery();
  return (
    <div>
      <Routes>
        <Route element={<UserRoute />}>
          <Route path="/" element={<Login />} />
          <Route path='/admin' element={<AdminLoginContainer />}></Route>
          <Route path='/consultant' element={<ConsultantLoginContainer />}></Route>
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgot-password" element={<ForgetPassword />} />
          <Route path="/consultant-forgot-password" element={<ConsultantForgetPassword />} />
          <Route path="/forgot-username" element={<ForgetUsername />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/createquery" element={<CreateQuery />} />
          <Route path="/query-details/:id" element={<QueryDetails />} />
          <Route path="/edit-query-details/:id" element={<EditQuery />} />
          <Route path="/user-profile" element={<UserProfile />} />
          <Route path="/consultant-profile" element={<UserProfile isAdmin={false}/>} />
          
        </Route>
        <Route element={<AdminRoute />}>
          <Route path="/user-list" element={<UserList />} />
          <Route path="/enduser-list" element={<EndUserList />} />
          <Route path="/admin-profile" element={<UserProfile isAdmin={true}/>} />
          <Route path="/admin-user-signup" element={<AdminUserSignup />} />
          <Route path="/add-user" element={<AddUser />} />
        </Route>
      </Routes>
      <ToastContainer icon={false} />
    </div>
  );
};

export default App;
